<template>
  <div class="file-single">
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="document_.DocumentID"
        readonly
        :placeholder="$t('message.contracts.document_number')"
        autocomplete="off"
        style="cursor: auto"
        id="document_number"
      />
      <label for="document_number" class="form-label-group-label shorter">{{
        $t("message.contracts.document_number")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <!-- <b-form-datepicker :locale="locale" v-model="document_.DocumentDate" :placeholder="$t('message.contracts.document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_date"></b-form-datepicker>
			<label  v-if="document_.DocumentDate!=''"  for="document_date" class="form-label-group-label shorter topped">{{$t('message.contracts.document_date')}}</label> -->

      <datepicker
        value-type="YYYY-MM-DD"
        format="DD.MM.YYYY"
        @focus="document_.DocumentDate = ' '"
        @blur="
          document_.DocumentDate == ' '
            ? (document_.DocumentDate = '')
            : (document_.DocumentDate = document_.DocumentDate)
        "
        inputClass="form-control"
        v-model="document_.DocumentDate"
        :placeholder="$t('message.contracts.document_date')"
        :inputAttr="{ id: 'document_date' }"
      />
      <label
        for="document_date"
        class="form-label-group-label shorter"
        :class="
          document_.DocumentDate != '' && document_.DocumentDate != null
            ? 'topped'
            : ''
        "
        >{{ $t("message.contracts.document_date") }}</label
      >
    </span>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group',
        document_types_focused ? 'focused' : '',
      ]"
    >
      <v-select-popup
        :indata="document_types"
        :placeholder="$t('message.contracts.document_types')"
        v-model="document_.attis_contract_doc_type"
      />
      <!-- <v-select id="document_types" :options="document_types" label="display_text" :class="['form-control', document_.document_type!==''?'vs--selected':'']" v-model="document_.attis_contract_doc_type" :placeholder="$t('message.contracts.document_types')" @focus="docTypeFocused" @blur="docTypeBlurred"></v-select>
			<label for="document_types" class="form-label-group-label shorter">{{$t('message.contracts.document_types')}}</label> -->
    </span>
    <div :class="['bmd-form-group mb-2 d-block form-label-group']">
      <div v-if="files && files.length > 0">
        <div class="d-flex">
          <!-- <div>
						{{$t('message.contracts.document_file')}}: 
					</div> -->
          <div>
            <div v-for="file in files" :key="file.id">
              <a target="_blank" :href="'/document/getfile/' + file.id">
                <i class="fas fa-arrow-down"></i> {{ file.name }}</a
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="document_.DocGuid != ''">
        {{ $t("message.contracts.document_file") }}:
        <a target="_blank" :href="'/document/getfile/' + document_.DocGuid">
          <i class="fas fa-arrow-down"></i> {{ document_.DocumentNumber
          }}{{ document_.FileType }}</a
        >
        <button class="btn btn-link text-danger btn-sm" @click="removeFile()">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <div v-for="(file, index) in files_att" class="row" :key="index">
      <div class="col-11">
        <input
          :disabled="files_loading"
          type="file"
          @change="attachFile($event, index)"
          class="mb-2"
        />
      </div>
      <div class="col-1">
        <button
          class="btn btn-sm btn-link text-danger"
          @click="removeFile1(index)"
        >
          &times;
        </button>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div v-if="files_loading">{{ $t("message.wait") }}</div>
        <div v-else class="d-flex justify-space-between mt-2">
          <button
            :disabled="files_loading"
            class="btn btn-sm btn-outline-success"
            @click="addAttachement"
          >
            {{ $t("message.contracts.add_attachement") }}
          </button>
          <button
            :disabled="files_loading"
            class="btn btn-sm btn-success ml-2"
            v-if="files_att.length > 0"
            @click="upload_files"
          >
            {{ $t("message.contracts.upload") }}
          </button>
        </div>
        <br />
        <!-- <small><i>{{$t('message.contracts.add_attachement_info')}}</i></small> -->
      </div>
      <pdf
        :user_id="contract_details.attis_contract_owner"
        :document="document_"
        :goods="goods"
        :doc_id="document_.DocumentID"
        :source="source"
      ></pdf>
    </div>

    <!-- <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="document_.DocGuid==''">
			<input type="file" class="form-control" :placeholder="$t('message.contracts.document_file')" autocomplete="off" style="cursor: auto;" id="document_number" @change="fileSelected($event)">
			<label for="document_file" class="form-label-group-label shorter pb-0">{{$t('message.contracts.document_file')}}</label>
		</span> -->

    <div class="text-center mt-4" v-if="loading">
      <img src="tenor.gif" alt="" />
      <div>{{ $t("message.wait") }}</div>
    </div>

    <form-invoice
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'invoice'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-invoice>
    <form-cmr
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'cmr'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-cmr>
    <form-fm1
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'fm1'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-fm1>
    <form-epi
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'epi'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-epi>
    <form-awb
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'awb'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-awb>
    <form-rwb
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'rwb'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-rwb>
    <form-insurance
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'insurance'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-insurance>
    <form-liability-insurance
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'liability-insurance'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-liability-insurance>
    <form-packaging
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'packaging'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-packaging>

    <form-sad
      :files="files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'sad'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-sad>
    <form-ktg-attorney
      :files="files"
      @file="catch_files"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value == 'ktg_attorney'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
    ></form-ktg-attorney>

    <form-specification
      v-if="
        document_.attis_contract_doc_type.value == 'specification' ||
        document_.attis_contract_doc_type.value == 'Спецификация'
      "
      :goods="goods"
      :contract_details="contract_details"
      :document_id="document_.document_id"
      :document="document_"
      :files="files"
    ></form-specification>

    <br /><br />
    <button
      class="btn btn-success"
      @click="saveDocument()"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value !== 'epi' &&
        document_.attis_contract_doc_type.value !== 'fm1' &&
        document_.attis_contract_doc_type.value !== 'sad' &&
        document_.attis_contract_doc_type.value !== 'invoice' &&
        document_.attis_contract_doc_type.value !== 'cmr' &&
        document_.attis_contract_doc_type.value !== 'awb' &&
        document_.attis_contract_doc_type.value !== 'rwb' &&
        document_.attis_contract_doc_type.value !== 'packaging' &&
        document_.attis_contract_doc_type.value !== 'insurance' &&
        document_.attis_contract_doc_type.value !== 'liability-insurance' &&
        document_.attis_contract_doc_type.value !== 'ktg_attorney' &&
        document_.attis_contract_doc_type.value !== 'specification' &&
        document_.attis_contract_doc_type.value !== 'Спецификация'
      "
      :disabled="loading"
    >
      {{ $t("message.contracts.document_save") }}
    </button>
    <!--<button class="btn btn-outline-danger float-right" @click="deleteDocument()">{{$t('message.delete')}}</button>-->
    <button
      class="btn btn-outline-danger btn-sm float-right"
      @click="cancel()"
      style="bottom: 16px; position: absolute; right: 20px"
      :disabled="loading"
    >
      {{ $t("message.cancel") }}
    </button>
  </div>
</template>
<script>
import FormKtgAttorney from "../contracts/form-ktg-attorney.vue";
import formPackaging from "../contracts/form-packaging.vue";
// import pdf from './../contracts/pdf-generation/pdf-widget';

export default {
  name: "file-single",
  // components: [pdf],
  components: { formPackaging, FormKtgAttorney },
  props: ["document", "goods", "contract_details"],
  data() {
    return {
      files_att: [],
      files: [],
      files_loading: false,
      document_: {},
      document_types_focused: false,
      loading: false,
      document_types: [
        {
          value: "invoice",
          display_text: this.$t("message.contracts.document_invoice"),
        },
        {
          value: "cmr",
          display_text: this.$t("message.contracts.document_cmr"),
        },
        {
          value: "fm1",
          display_text: this.$t("message.contracts.document_fm1"),
        },
        {
          value: "epi",
          display_text: this.$t("message.contracts.document_epi"),
        },
        {
          value: "awb",
          display_text: this.$t("message.contracts.document_awb"),
        },
        {
          value: "rwb",
          display_text: this.$t("message.contracts.document_rwb"),
        },
        {
          value: "insurance",
          display_text: this.$t("message.contracts.document_insurance"),
        },
        {
          value: "liability-insurance",
          display_text: this.$t(
            "message.contracts.document_liability_insurance",
          ),
        },
        {
          value: "packaging",
          display_text: this.$t("message.contracts.document_packaging"),
        },
        {
          value: "sad",
          display_text: this.$t("message.contracts.document_sad"),
        },
        {
          value: "ktg_attorney",
          display_text: this.$t("message.contracts.document_ktg_attorney"),
        },
        {
          value: "specification",
          display_text: this.$t("message.contracts.document_specification"),
        },
      ],
    };
  },
  mounted() {
    this.$root.$on("show-loading", () => {
      this.loading = true;
    });
    this.$root.$on("unshow-loading", () => {
      this.loading = false;
    });
    // this.$root.$on('open_document_for_error', (error_data) => {
    // 	//this.document = error_data.document;
    // 	if (error_data.Subsection == 'Epi') {
    // 		this.document_.document_id = error_data.Id;
    // 		this.document_.attis_contract_doc_type.value = 'epi';
    // 	}
    // 	if (error_data.Subsection == 'PackingList') {
    // 		this.document_.document_id = error_data.Id;
    // 		this.document_.attis_contract_doc_type.value = 'packaging';
    // 	}
    // 	if (error_data.Subsection == 'Invoice') {
    // 		this.document_.document_id = error_data.Id;
    // 		this.document_.attis_contract_doc_type.value = 'invoice';
    // 	}
    // 	setTimeout(() => {
    // 		this.$root.$emit('go_to_document_error', error_data);
    // 	}, 500)
    // })
    this.$root.$on("open_document_for_error", (error_data) => {
      this.document_ = this.document;
      if (error_data.Section == "Document") {
        if (error_data.Subsection == "Epi") {
          var epiType = { value: "epi", display_text: "epi" };
          this.document_.document_id = error_data.Id;
          this.document_.attis_contract_doc_type = epiType;
          setTimeout(() => {
            this.$root.$emit("go_to_epi_error", error_data);
          }, 500);
        }
        if (error_data.Subsection == "PackingList") {
          var packingType = { value: "packaging", display_text: "packaging" };
          this.document_.document_id = error_data.Id;
          this.document_.attis_contract_doc_type = packingType;
          setTimeout(() => {
            this.$root.$emit("go_to_packaging_error", error_data);
          }, 500);
        }
        if (error_data.Subsection == "Invoice") {
          var invoiceType = { value: "invoice", display_text: "invoice" };
          this.document_.document_id = error_data.Id;
          this.document_.attis_contract_doc_type = invoiceType;
          setTimeout(() => {
            this.$root.$emit("go_to_invoice_error", error_data);
          }, 1000);
        }
      } else if (error_data.Section == "Contract") {
        setTimeout(() => {
          this.$root.$emit("process-document-error-to-contract", error_data);
        }, 500);
      }
    });
    this.document_ = this.document;
    var doct = { value: "", display_text: "" };
    this.document_types.forEach((item) => {
      if (typeof item !== "undefined") {
        if (item.value.toLowerCase() == this.document.DocType.toLowerCase())
          doct = item;
        if (item.value == "invoice" && this.document.DocType == "Инвойс")
          doct = item;
        if (item.value == "epi" && this.document.DocType == "ЭПИ") doct = item;
        if (
          item.value == "specification" &&
          this.document.DocType == "Спецификация"
        )
          doct = item;
        if (item.value == "fm1" && this.document.DocType == "ФМ-1") doct = item;
        if (
          item.value == "awb" &&
          (this.document.DocType == "AWB" || this.document.DocType == "АВБ")
        )
          doct = item;
        if (
          item.value == "rwb" &&
          (this.document.DocType == "RWB" ||
            this.document.DocType == "Железнодорожная накладная")
        )
          doct = item;
        if (
          item.value == "packaging" &&
          this.document.DocType == "Пакинг лист"
        ) {
          doct = item;
          console.log(doct);
        }
        if (
          item.value == "insurance" &&
          (this.document.DocType == "Страховка" ||
            this.document.DocType == "страховка" ||
            this.document.DocType == "insurance" ||
            this.document.DocType == "Insurance")
        ) {
          doct = item;
        }
        if (
          item.value == "liability-insurance" &&
          (this.document.DocType == "Cтраховка ответственности" ||
            this.document.DocType == "страховка ответственности" ||
            this.document.DocType == "liability insurance" ||
            this.document.DocType == "Liability Insurance")
        ) {
          doct = item;
        }
        if (
          item.value == "sad" &&
          (this.document.DocType == "SAD" ||
            this.document.DocType == "САД" ||
            this.document.DocType == "сад" ||
            this.document.DocType == "ГТД" ||
            this.document.DocType == "гтд" ||
            this.document.DocType == "GTD")
        ) {
          doct = item;
        }
        if (
          item.value == "ktg_attorney" &&
          (this.document.DocType == "Доверенность КТЖ" ||
            this.document.DocType == "доверенность КТЖ" ||
            this.document.DocType == "KTZ power of attorney")
        ) {
          doct = item;
        }
      }
    });
    this.document_.document_id = this.document.DocumentID;
    this.document_.attis_contract_doc_type = doct;
  },
  methods: {
    unify_doctypes(doctype) {
      switch (doctype) {
        case "invoice":
        case "Инвойс":
          return "invoice";
          break;
        case "epi":
        case "ЭПИ":
          return "epi";
          break;
        case "fm1":
        case "ФМ-1":
          return "fm1";
          break;
        case "awb":
        case "AWB":
        case "АВБ":
          return "awb";
          break;
        case "rwb":
        case "RWB":
        case "Железнодорожная накладная":
          return "rwb";
          break;
        case "packaging":
        case "Пакинг лист":
          return "packaging";
          break;
        case "insurance":
        case "Страховка":
        case "страховка":
        case "Insurance":
          return "insurance";
          break;
        case "liability-insurance":
        case "Cтраховка ответственности":
        case "liability-insurance":
          return "liability-insurance";
          break;
        case "САД":
        case "сад":
        case "SAD":
        case "sad":
        case "ГТД":
        case "гтд":
        case "GTD":
        case "gtd":
          return "sad";
          break;
        case "ktg_attorney":
        case "Доверенность КТЖ":
        case "KTZ power of attorney":
          return "ktg_attorney";
          break;
      }
    },
    upload_files() {
      for (let i = this.files_att.length - 1; i >= 0; i--) {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", this.files_att[i]);
        axios
          .post(
            window.base +
              "/document/UploadFile?docid=" +
              this.contract_details.attis_contract_id +
              "&type=" +
              this.unify_doctypes(this.document_.attis_contract_doc_type.value),
            fd,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            this.files.push(response.data);
            this.files_att.splice(i, 1);
            this.files_loading = false;
          });
      }
      // var fd = new FormData
      // this.files_att.forEach((i, ndx)=>{
      // 	fd.append('Files['+ndx+']', i)
      // })
      // axios.post(window.base+'/document/UploadFile?documentid='+this.document.DocumentID+'&docid='+this.contract_details.attis_contract_id+'&type='+this.unify_doctypes(this.document.DocType), fd, {headers: { 'Content-Type': 'multipart/form-data' }}).then(response=>{
      // 	this.files_att = []
      // 	//this.$set(this, 'files', response.data)
      // 	this.files.push(response.data)
      // })
    },
    addAttachement() {
      this.files_att.push("");
    },
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile1(index) {
      this.files_att.splice(index, 1);
    },
    catch_files(data) {
      this.files = data;
    },
    fileSelected(event) {
      if (typeof event.target.files[0] !== "undefined") {
        console.log(event.target.files[0]);
        if (event.target.files[0].size / 1000000 < 20)
          this.$set(this.document_, "file", event.target.files[0]);
        else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.file_too_big20"),
            timeout: 5000,
          }).show();
          document.querySelector("#document_file").value = "";
        }
      } else this.document_.file = false;
    },
    // deleteDocument(){
    // 	this.$bvModal.msgBoxConfirm(this.$t('message.contracts.document_delete_message'), {
    //          title: this.$t('message.confirm'),
    //          size: 'sm',
    //          buttonSize: 'sm',
    //          okVariant: 'danger',
    //          okTitle: this.$t('message.yes'),
    //          cancelTitle: this.$t('message.no'),
    //          footerClass: 'p-2',
    //          hideHeaderClose: false,
    //          centered: true
    //        })
    //          .then(value => {
    //          	if(value){
    //          		axios.get(window.base+'/Document/Delete?doc_id='+this.document_.DocumentID).then(()=>{
    //          			this.$root.$emit('loadDocuments', {category: 'all'})
    //          			this.$root.$emit('bv::hide::modal', 'modal-document', '#btnShow')
    //          		})
    //          	}
    //          })
    //          .catch(err => {
    //            // An error occurred
    //          })
    // },
    docTypeFocused() {
      this.document_types_focused = true;
    },
    docTypeBlurred() {
      this.document_types_focused = false;
    },
    removeFile() {
      axios.get(
        window.base +
          "/fileRemove?doc_id=" +
          this.document_.DocumentID +
          "&doc_guid=" +
          this.document_.DocGuid,
      );
      this.document_.DocGuid = "";
    },
    saveDocument() {
      this.$root.$emit("saveDocument", {
        document: this.document_,
        contract: this.contract_details,
      });
      // this.$root.$emit('bv::hide::modal', 'modal-document', '#btnShow')
    },
    cancel() {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.contracts.document_cancel_message"), {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  computed: {
    source() {
      if (
        typeof this.document_.attis_contract_doc_type != "undefined" &&
        typeof this.document_.attis_contract_doc_type.value !== "undefined"
      )
        return this.document_.attis_contract_doc_type.value;
      return {};
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
};
</script>
